import React, { useState, useEffect } from 'react';

const Redirect = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [installationStatus, setInstallationStatus] = useState({
    loading: true,
    success: false,
    error: null
  });

  useEffect(() => {
    const handleOAuthFlow = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const isDemo = urlParams.get('demo') !== null;

        // If demo parameter exists, skip OAuth validation and show success
        if (isDemo) {
          setInstallationStatus({
            loading: false,
            success: true,
            error: null
          });
          return;
        }

        const redirectUri = window.location.origin + window.location.pathname;

        if (!code) {
          throw new Error('No authorization code received from Slack');
        }

        const SLACK_CLIENT_ID = "1612652226374.8694576429319";
        const SLACK_CLIENT_SECRET = process.env.REACT_APP_SLACK_CLIENT_SECRET;
        console.log(SLACK_CLIENT_SECRET)

        if (!SLACK_CLIENT_ID || !SLACK_CLIENT_SECRET) {
          throw new Error('Slack credentials not properly configured');
        }

        const response = await fetch('https://slack.com/api/oauth.v2.access', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            code,
            client_id: SLACK_CLIENT_ID,
            client_secret: SLACK_CLIENT_SECRET,
            redirect_uri: redirectUri
          })
        });

        const data = await response.json();

        if (!data.ok) {
          throw new Error(data.error || 'Failed to complete Slack installation');
        }

        if (data.access_token) {
          sessionStorage.setItem('slackToken', data.access_token);
        }

        if (data.team) {
          sessionStorage.setItem('slackTeamName', data.team.name);
          sessionStorage.setItem('slackTeamId', data.team.id);
        }

        if (data.authed_user) {
          sessionStorage.setItem('slackUserId', data.authed_user.id);
        }

        if (data.bot_token) {
          sessionStorage.setItem('slackBotToken', data.bot_token);
        }

        setInstallationStatus({
          loading: false,
          success: true,
          error: null
        });

      } catch (error) {
        console.error('OAuth Error:', error);
        setInstallationStatus({
          loading: false,
          success: false,
          error: error.message || 'An unknown error occurred'
        });
      }
    };

    handleOAuthFlow();
  }, []);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleContinue = () => {
    if (isChecked) {
      console.log('User CONSENTED to SMS/calls.');
    } else {
      console.log('User DID NOT consent to SMS/calls.');
    }
    window.location.href = '/final-confirmation';
  };

  if (installationStatus.loading) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f6f6f6', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', margin: 0 }}>
        <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px', width: '100%' }}>
          <h1 style={{ color: '#333' }}>Installing App...</h1>
          <p style={{ color: '#555' }}>Please wait while we complete your Slack app installation.</p>
          <div style={{ display: 'inline-block', width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #0066cc', borderRadius: '50%', animation: 'spin 2s linear infinite', marginTop: '20px' }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (installationStatus.error) {
    return (
      <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f6f6f6', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', margin: 0 }}>
        <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px', width: '100%' }}>
          <h1 style={{ color: '#cc0000' }}>Installation Failed</h1>
          <p style={{ color: '#555' }}>{installationStatus.error}</p>
          <p style={{ color: '#555', marginTop: '1rem' }}>
            Please try again or contact support if the problem persists.
          </p>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              backgroundColor: '#0066cc',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              width: '100%',
              marginTop: '1rem'
            }}
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f6f6f6', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', margin: 0 }}>
      <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px', width: '100%' }}>
        <h1 style={{ color: '#333' }}>Installation Complete</h1>
        <p style={{ color: '#555' }}>Your Slack app has been successfully installed.</p>
        <p style={{ color: '#555' }}>
          You can now use the <code>/page</code> command in Slack.
        </p>
        <div style={{ marginTop: '1.5rem', borderTop: '1px solid #eee', paddingTop: '1.5rem', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1rem' }}>
            <input
              type="checkbox"
              id="twilioOptIn"
              checked={isChecked}
              onChange={handleCheckboxChange}
              style={{ marginRight: '10px', marginTop: '5px' }}
              aria-describedby="consentDescription"
            />
            <label
              htmlFor="twilioOptIn"
              id="consentDescription"
              style={{ color: '#555', fontSize: '14px', lineHeight: '1.5' }}
            >
              <strong>Optional:</strong> Check this box if you would like to receive essential SMS messages and phone calls from Rimble regarding service notifications and account updates.
              <br /><br />
              <strong>This is not required to use our service.</strong>
              <br /><br />
              Message and data rates may apply. Message frequency varies based on your activity. Reply HELP for help or STOP to cancel anytime.
              <br /><br />
              View our <a href="/privacypolicy" style={{ color: '#0066cc' }}>Privacy Policy</a> and <a href="/terms" style={{ color: '#0066cc' }}>Terms of Service</a>.
            </label>
          </div>
          <button
            onClick={handleContinue}
            style={{
              backgroundColor: '#0066cc',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              width: '100%',
              marginTop: '1rem',
            }}
          >
            Continue to Confirmation
          </button>
        </div>
      </div>
    </div>
  );
};

export default Redirect;
